import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { CategoryStoreSelectors } from '@era/stores';

@Component({
  selector: 'era-room-number',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './room-number.container.html',
})
export class RoomNumberComponent {
  private readonly store = inject(Store);

  readonly categoryId = input.required<string>();

  readonly roomNumber = computed(() => {
    const id = this.categoryId();
    if (!id) return '';

    const room = this.store.selectSignal(CategoryStoreSelectors.selectCategoryByCategoryId('Room', id))();

    return room?.entity?.displayName ?? '';
  });
}
